import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  Row,
  Col,
  Label,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvForm, AvField } from "availity-reactstrap-validation";
import CustomSelect from "../../../../../../components/Common/CustomSelect";

const EditUserModal = props => {
  const { isOpen, toggle, data, positions, languages, permissions } = props;
  const statuses = [
    {
      value: 'true',
      label: 'Active',
    }, {
      value: 'false',
      label: 'Inactive'
    }
  ]

  const [selectedPositions, setSelectedPositions] = React.useState([]);
  const [selectedLanguage, setSelectedLanguage] = React.useState("");
  const [selectedStatus, setSelectedStatus] = React.useState("");
  const [selectedShowInHR, setSelectedShowInHR] = React.useState("");

  const canEditPosition = React.useMemo(() => {
    return (
      permissions["is_admin"] ||
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_head_of_accountmanager"]
    );
  }, [permissions]);

  React.useEffect(() => {
    if (canEditPosition) {
      if (data.positions.length > 0 && isOpen) {
        data.positions.map(i => {
          selectedPositions.push({
            label: i.title,
            value: i.id,
          });
        });
      } else {
        setSelectedPositions([]);
      }
    }
    if (languages !== null && isOpen) {
      let selectedLang = languages.findIndex(i => i.value === data.lang);
      setSelectedLanguage(languages[selectedLang]);
    }
    setSelectedStatus(data.is_active ? statuses[0] : statuses[1])
    setSelectedShowInHR(data.show_in_hr_report ? statuses[0] : statuses[1])
  }, [isOpen]);

  const onSubmitForm = (e, errors, params) => {
    if (errors?.length === 0) {
      let currentData = {
        email: params.email,
        first_name: params.first_name,
        last_name: params.last_name,
        phone: params.phone,
        username: params.username,
      };

      if (params?.positions && Object.keys(params?.positions).length) {
        currentData["positions"] = [];
        currentData["is_active"] = selectedStatus?.value || data?.is_active;
        currentData["show_in_hr_report"] = selectedShowInHR?.value || data?.show_in_hr_report;
        params.positions.map(i => {
          currentData["positions"].push({
            title: i.label,
            id: i.value,
          });
        });
      }

      if (Object.keys(params?.lang).length) {
        currentData["lang"] = params.lang.value;
      }

      props.userPatchProfile(props.userId, currentData);
      toggle();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      toggle={toggle}
      size="xl"
    >
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          Edit profile
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmitForm}>
        <ModalBody>
          <Row>
            <Col lg={4}>
              <div className="mb-3">
                <Label htmlFor="position">Status</Label>
                <CustomSelect
                  name={"is_active"}
                  options={statuses}
                  placeholder="Select status..."
                  defaultValue={selectedStatus || ""}
                  onChange={setSelectedStatus}
                  classNamePrefix="select2-selection"
                  errorMessage="Status is required!"
                />
              </div>
            </Col>
            {permissions["is_admin"] && (
              <Col lg={4}>
                <div className="mb-3">
                  <Label htmlFor="position">Show in HR report</Label>
                  <CustomSelect
                    name={"is_active"}
                    options={statuses}
                    placeholder="Select status..."
                    defaultValue={selectedShowInHR || ""}
                    onChange={setSelectedShowInHR}
                    classNamePrefix="select2-selection"
                    errorMessage="Status is required!"
                  />
                </div>
              </Col>
            )}
          </Row>
          <Row>
            <Col md={4}>
              <div className="mb-3">
                <AvField
                  name="username"
                  label="Username"
                  placeholder="Username..."
                  type="text"
                  value={data?.username}
                  validate={{
                    required: true,
                    minLength: {
                      value: 3,
                      errorMessage: "Min 3 words",
                    },
                  }}
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <AvField
                  name="first_name"
                  label="First name"
                  placeholder="First name..."
                  type="text"
                  value={data?.first_name}
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <AvField
                  name="last_name"
                  label="Last name"
                  placeholder="Last name..."
                  type="text"
                  value={data?.last_name}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <AvField
                  name="email"
                  label="Email"
                  placeholder="user@example.com"
                  value={data?.email}
                  className="form-control"
                  type="email"
                  required
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <AvField
                  name="phone"
                  label="Mobile"
                  placeholder="Phone number..."
                  type="number"
                  value={data?.phone}
                />
              </div>
            </Col>

            {canEditPosition && (
              <Col lg={6}>
                <div className="mb-3">
                  <Label htmlFor="position">Positions</Label>
                  <CustomSelect
                    name={"positions"}
                    isMulti
                    options={
                      positions.map(i => {
                        return {
                          label: i.title,
                          value: i.id,
                        };
                      }) || []
                    }
                    placeholder="Select position..."
                    defaultValue={selectedPositions || []}
                    onChange={setSelectedPositions}
                    classNamePrefix="select2-selection"
                    errorMessage="Client is required!"
                  />
                </div>
              </Col>
            )}

            <Col lg={6}>
              <div className="mb-3">
                <Label htmlFor="position">Language</Label>
                <CustomSelect
                  name={"lang"}
                  options={languages}
                  placeholder="Select language..."
                  defaultValue={selectedLanguage || ""}
                  onChange={setSelectedLanguage}
                  classNamePrefix="select2-selection"
                  errorMessage="Client is required!"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-success save-user ms-2"
                >
                  Save changes
                </button>
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

EditUserModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.any,
  permissions: PropTypes.any,
  positions: PropTypes.any.isRequired,
  userId: PropTypes.string.isRequired,
  userPatchProfile: PropTypes.func.isRequired,
  languages: PropTypes.array.isRequired,
};

export default EditUserModal;
